<template>
  <div class>
    <section class="summary-collapse">
      <van-collapse v-model="activeNames">
        <van-collapse-item name="2">
          <div class="col-title" slot="title">
            缺勤
            <span class="slot-days">{{ subBody.ABSENT_TOTAL }}</span>
          </div>
          <section
            v-for="(item, index) in subBody.ABSENT"
            :key="index"
            class="summary"
          >
            <div>
              <p>
                <span class="p-name"
                  ><label>姓名：</label>{{ item.C_NAME }}</span
                >
                <span class="p-title"
                  ><label>工号：</label>{{ item.EMPLID }}</span
                >
              </p>
              <p>
                <span class="p-name"
                  ><label>职位：</label>{{ item.POSN_DESCR }}</span
                >
                <span class="p-title"
                  ><label>部门：</label>{{ item.DEPT_DESCR }}</span
                >
                <!-- <label>{{ item.POSN_DESCR }}<span class="posn-span"></span>{{ item.DEPT_DESCR }}</label> -->
              </p>
              <p>
                <span
                  ><label>旷工日期：</label
                  >{{ item.C_WORK_DATE | datefmt }}</span
                >
                <span class="p-title p-day"
                  ><label>旷工时间：</label>{{ item.C_DURATION }}</span
                >
              </p>
            </div>
          </section>
        </van-collapse-item>
      </van-collapse>
    </section>
  </div>
</template>

<script>
  import dateformat from '@/utils/dateformat';

  export default {
    props: ['subBody'],
    data() {
      return {
        activeNames: ['1']
      };
    },
    methods: {},
    filters: {
      datefmt(val) {
        if (!val) return '';
        return dateformat('yyyy/MM/dd', new Date(val));
      },
      timeFmt(val) {
        if (!val) return '';
        let nTime = parseFloat(val);
        if (isNaN(nTime)) return val;
        nTime = nTime / 60.0;
        return new Number(nTime).toFixed(1);
      }
    }
  };
</script>

<style lang="less" scoped>
  .summary-collapse {
    margin-top: 10px;
  }
  .col-title {
    font-size: 16px;
  }
  .slot-days {
    float: right;
    color: #b2b2b2;
    font-size: 16px;
  }
  .summary {
    margin: 10px 0px 0;
    border-bottom: 1px dotted #aeb5c2;
    background: white;
    border-radius: 10px;
    div {
      font-size: 14px;
      line-height: 30px;
      p {
        span {
          color: black;
        }
        span.p-name {
          font-size: 14px;
        }
        span.p-title {
          float: right;
        }
        span.p-day {
          color: red;
        }
        label {
          color: #aaa !important;
        }
      }
    }
  }
  .posn-span {
    display: inline-block;
    width: 30px;
  }
</style>
